import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { HomePage } from "../HomePage/HomePage";
import { history } from "../_helpers/history";
import "./style.css";
import { PrivateRoute } from "../_components/PrivateRoute/PrivateRoute";
import { LoginPage } from "../LoginPage/LoginPage";
import { RawLayout } from "../_components/Layout/RawLayout";
import { EAgreements } from "../EAgreements/EAgreements";
import { EInvoices } from "../EInvoices/EInvoices";
import { Logout } from "../Logout/Logout";
import { LoggedInLayout } from "../_components/Layout/LoggedInLayout";
import { ResetPasswordPage } from "../ResetPasswordPage/ResetPassword";

const App = () => {
  return (
    <>
      <Router history={history}>

        <LoggedInLayout>

          <Route path="/login" component={LoginPage} />

          <Route path="/logout" component={Logout} />
          <Route path="/Reset" component={ResetPasswordPage} />

          <PrivateRoute path="/" exact component={HomePage} />
          <PrivateRoute path="/agreements" exact component={EAgreements} />
          <PrivateRoute path="/invoices" exact component={EInvoices} />
        </LoggedInLayout>
      </Router>
    </>
  );
};

export default App;
